import { useStore } from 'effector-react'
import { BalanceNav } from '~/widgets/blocks/BalanceNav'
import { Stories } from '~/widgets/Stories'
import { DriverCurrentOccupation } from '~/features/DriverOccupations'
import { RentalContract } from '~/features/RentalContract'
import { RentalContractSigningAlert } from '~/features/RentalContractSigning'
import { GoToInspectionsButton } from '~/entities/Inspection'
import { BalanceDropdown, CurrentBalance } from '~/entities/MainBalance'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { PageContainer } from '~/shared/ui/PageContainer'
import { Wrapper } from './styled'
import { useRefreshPage } from './useRefreshPage'

export function HomePage() {
  const { refreshPage } = useRefreshPage()
  const featureFlags = useStore(featureFlagModel.$featureFlags)

  return (
    <PageContainer
      canMenu
      title='Апарк. Водитель'
      extraHeader={
        featureFlags.visibility_all_balances ? (
          <BalanceDropdown />
        ) : (
          <CurrentBalance />
        )
      }
      topContent={<RentalContract />}
      onRefreshPage={refreshPage}
    >
      <Wrapper>
        <Stories />
        <RentalContractSigningAlert />
        <BalanceNav />
        <GoToInspectionsButton />
        {featureFlags.driver_occupations && <DriverCurrentOccupation />}
      </Wrapper>
    </PageContainer>
  )
}
